module.exports = __webpack_public_path__ + "static/img/select-categ.4824bcc8.png";